module.exports = __webpack_public_path__ + "img/others_04.0ea7fa10.jpg";